<template>
  <el-dialog
    :title="$t('ExcelConfig.Title')"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="hide"
    destroy-on-close
  >
    <p>{{ $t('ExcelConfig.Import') }}</p>
    <div class="text">
      1.{{ $t('ExcelConfig.AfterDownload') }}<br />
      2.{{ $t('ExcelConfig.ImportExcel') }}
      <el-button type="primary" @click="onDownload">{{ $t('ExcelConfig.Download') }}</el-button><br />
      3.{{ $t('ExcelConfig.MustHave') }}<br />
      4.{{ $t('ExcelConfig.Supports') }}<br />
    </div>
    <div>
      <BjImportFile
        ref="BjImportFile"
        accept=".xls,.xlsx,.csv"
        :limit-size="128 * 1024"
        auto-upload
        @importFile="importFile"
      >
        <template #top> </template>
        <template slot="default"> {{ $t('ExcelConfig.maximum') }} </template>
      </BjImportFile>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" :disabled="!bstop" @click="confirm">{{ $t('ExcelConfig.Confirm') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { purchaseApi, settingApi, importApi } from '@/api';
import { downloadBlob, getEnvGlobalConfig } from '@/utils/index';
const DEFAULT_BUCKET_NAME = getEnvGlobalConfig('VUE_APP_UPLOAD_BUCKET_NAME');
import moment from 'moment';
export default {
  data() {
    return {
      dialogVisible: false,
      file: null,
      tableData: [], // 存放上传的excel文件的数据
      tableSku: [], // 存放临时SKU
      bstop: true
    };
  },
  methods: {
    show() {
      this.file = null;
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    onDownload() {
      importApi.getImportTemplateHeaders({
        templateCode: 'SPUR.PURCHASE_ORDER_GOODS_IMPORT',
        size: 1,
        page: 0,
        total: 1,
        pageSize: 1,
        currentPage: 0
      }).then(res => {
        settingApi
          .downloadFileByUrl({
            bucketName: DEFAULT_BUCKET_NAME,
            url: res.content[0].templateUrl,
          })
          .then(resp => {
            const fileName = res.content[0].templateFileName;
            downloadBlob(resp, `Inbound_SKU_import_template.${fileName.split('.').pop()}`);
          });
      });
    },
    importFile(file) {
      this.bstop = true;
      this.tableData = [];
      const _this = this;
      _this.tableSku = [];
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = function () {
        const buffer = reader.result;
        const bytes = new Uint8Array(buffer);
        const length = bytes.byteLength;
        let binary = '';
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        const XLSX = require('xlsx');
        const wb = XLSX.read(binary, {
          type: 'binary',
          cellDates: true
        });
        const outData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
        let newArr = []
        const duplicates = {};
        for (const item of Object.values(outData)) {
          if (!item['productSku']) {
            _this.bstop = false;
            _this.$message.error(`${_this.$t('inputText')} productSku`);
            return;
          }
          if (!item['quantity']) {
            _this.bstop = false;
            _this.$message.error(`quantity ${_this.$t('emptyWarningText1')}`);
            return;
          }
          if (/^(?:[0-9]\d*)$/.test(item['quantity']) == false) {
            _this.$message.error(`quantity ${_this.$t('formatErrorText')}`);
          }

          if (!!String(item['productSku']).trim() && item['quantity']) {
            const key = `${item['productSku']}-${item['batch']}`;  
            if (duplicates[key]) {
              newArr.push(`${item['productSku']}-${item['batch']}`)
            }else{
              duplicates[key] = true; 
            } 
            if(newArr.length > 0){
              _this.$message.warning(`${newArr[0]} ${_this.$t('dataDuplication')}`)
              _this.bstop = false;
              return;
            }

            let expiryDate;
            if (item['expiry'] instanceof Date) {
              expiryDate = moment(new Date(item['expiry'])).format('YYYY-DD-MM HH:mm:ss');
            } else {
              expiryDate = moment(item['expiry'], 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
            }
            const obj = {
              'skuCode': item['productSku'] && String(item['productSku']).trim(),
              'standardSkuCode': item['productSku'] && String(item['productSku']).trim(),
              'planQty': item['quantity'],
              'batchCode': item['batch'],
              'expiryDate': moment(expiryDate, 'YYYY-MM-DD HH:mm:ss').isValid() ? expiryDate : ''
            };

            _this.tableData.push(obj);
            _this.tableSku.push(String(item['productSku']).trim());
          } else {
            _this.bstop = false;
            _this.msgError(_this.$t('WarehouseManagement.form.msgErrorText'));
            return;
          }
        }
      };
    },
    confirm() {
      if (this.tableSku.length > 0) {
        purchaseApi.purchaseGoodsImport(this.tableSku).then(res => {
          // 对导出的excel数据进行去重
          // this.tableData = this.$lodash.unionBy(this.tableData, 'standardSkuCode');
          // 去重后的数据与接口返回的数据比较，如果不存在于返回的数据中则提示；
          // const differentItems = this.$lodash.differenceBy(this.tableData, res, 'standardSkuCode');
          const unionByTableData = this.$lodash.unionBy(this.tableData, 'standardSkuCode');
          const standardSkuCodes1 = this.$lodash.map(this.$lodash.map(unionByTableData, 'standardSkuCode'), String);
          const standardSkuCodes2 = this.$lodash.map(this.$lodash.map(res, 'standardSkuCode'), String);
          // 使用 differenceBy 来找出差异
          const differentItems = this.$lodash.differenceBy(standardSkuCodes1, standardSkuCodes2);
          if (differentItems.length > 0) {
            this.msgError(`SKU: ${differentItems.join('，')}${this.$t('BusinessPurchaseForecast.msgError')}`);
          }else {
            if (!res.length) return;
            const list = [];
            let goOn = false;
            let goOnList = []
            this.tableData.forEach(v2 => {
              res.forEach(v1 => {
                if(v1.isHide == 1){
                  goOn = true
                  goOnList.push(v1.standardSkuCode)
                }else{
                  if (v2.standardSkuCode == v1.standardSkuCode) {
                    list.push({...v2, ...v1});
                  }
                }
              });
            });
            if(goOn)return this.msgError(`${this.$t('BusinessPurchaseForecast.ps1')} ${goOnList.filter((item, index) => goOnList.indexOf(item) === index).join('，')}${this.$t('BusinessPurchaseForecast.ps2')}`);
            this.hide();
            setTimeout(() => {
              this.$emit('submit', list);
            }, 1000);
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  font-size: 12px;
  line-height: 2;
}
</style>
